import { forwardRef, Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { HouseholdGuardianInvitesService } from '@se-po/shared-data-access-services'
import { catchError, first, Observable, of } from 'rxjs'
import { CentralServiceResources as cs } from 'se-resource-types'

@Injectable({
  providedIn: 'root',
  useExisting: forwardRef(() => AddGuardianModalSubmitService)
})
export abstract class AddGuardianModalSubmitter {
  public abstract error: string
  public abstract submit(
    access: string, to: string, persona_id: number): Observable<cs.Households.PersonaGuardianInvite>

}

@Injectable({
  providedIn: 'root'
})
export class AddGuardianModalSubmitService implements AddGuardianModalSubmitter {
  public error: string
  public translationKey = 'SE_PO_SE_PERSONA_PICKER_FEATURE_ADD_GUARDIAN_MODAL.'

  constructor(
    private inviteService: HouseholdGuardianInvitesService,
    private translateService: TranslateService
  ) {
    // noop
  }

  public submit(access: string, to: string, persona_id: number): Observable<cs.Households.PersonaGuardianInvite> {
    this.error = null
    return this.inviteService.create(access, to, persona_id, 'persona-picker').pipe(
      first(),
      catchError(err => {
        this.error = this.translateService.instant(this.translationKey + 'NOTIFICATION.error')
        return of(null)
      })
    )
  }

}
